import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class PartService {
    constructor(http) {
        this.http = http;
        this.singular = 'part';
        this.plural = 'parts';
        this.editor = PLATFORM.moduleName('pages/quote-setup/parts/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`parts/filter/${loadOptions}`);
        return await response.json();
    }

    async create(part) {
        await this.http.fetch('parts', { method: 'POST', body: json(part) });
    }

    async update(part) {
        await this.http.fetch(`parts/${part.id}`, { method: 'PUT', body: json(part) });
    }

    async delete(id) {
        await this.http.fetch(`parts/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`parts/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`parts/top-three/${query}`);
        return await response.json();
    }

    async whereUsed(filter) {
        const response = await this.http.fetch(`parts/${filter.partId}/where-used`, { method: 'POST', body: json(filter) });
        return await response.json();
    }
}